import React from 'react';
import { TabList, Tab, TabPanel, Tabs } from '../Tabs.js';
const RecipientContent = (props) => {
    const defaultIndex = props.tabs
        .filter((tab) => !tab.shouldHide)
        .findIndex((tab) => tab.defaultIndex);
    return (React.createElement(Tabs, { defaultIndex: defaultIndex === -1 ? 0 : defaultIndex },
        React.createElement(TabList, { style: {
                margin: '0px -15px -1px',
            } }, props.tabs.map((tab) => !tab.shouldHide && (React.createElement(Tab, { className: tab.className, id: tab.id, key: tab.label, style: {
                fontSize: '0.85em',
                padding: '14px 6px 8px 6px',
            } },
            React.createElement(tab.icon, { style: {
                    margin: '0.1em 0 -0.1em 0',
                } }),
            ' ',
            tab.label)))),
        props.tabs.map((tab) => !tab.shouldHide && (React.createElement(TabPanel, { key: tab.label }, tab.children)))));
};
export default RecipientContent;
//# sourceMappingURL=RecipientContent.js.map